import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';

import {
  Heading,
  BaseText,
  SkeletonLoader,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { PortfolioCardV2 } from '@/modules/wealth/components/PortfolioCardV2';
import { PortfolioCategories } from '@/types/models';
import { IPortfolioList } from '@/types/models/Portfolio';
import { trackViewPortfolio } from './track-events';
import { PortfolioModule } from '@/store/modules/PortfolioModule';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfoliosList',
  setup(__props) {

const isFetching = computed(() => PortfolioModule.isFetching);
const isFetchFailed = computed(() => PortfolioModule.isFetchFailed);
const portfolios = computed(() => PortfolioModule.portfolios);

function fetchUserPortfolios() {
  PortfolioModule.fetchPortfolios();
}

const getLocation = (portfolio: IPortfolioList) => {
  if (portfolio.type === PortfolioCategories.VariableIncome) {
    return {
      name: 'wealthIndexPortfolio',
      params: { portfolioId: portfolio.id }
    };
  } else {
    return {
      name: 'wealthPortfolio',
      params: { id: portfolio.id, type: portfolio.type }
    };
  }
};

onMounted(() => {
  fetchUserPortfolios();
});

return { __sfc: true,isFetching, isFetchFailed, portfolios, fetchUserPortfolios, getLocation, Heading, BaseText, SkeletonLoader, HelperViewStatus, PortfolioCardV2, trackViewPortfolio }
}

})